import { Dispatch, SetStateAction, useMemo } from 'react';

import { SaveAlt } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import {
  MRT_GlobalFilterTextField,
  MRT_ShowHideColumnsButton,
  MRT_TableInstance,
  MRT_ToggleFullScreenButton,
} from 'material-react-table';
import { TableColumnsPreference } from 'src/types/wallet-monitor';

import MyTablePreferencesButton from '../MyTablePreferencesButton';

type ToolbarFundIndicatorsTableProps = {
  table: MRT_TableInstance<any>;
  disabled: boolean;
  walletId: number;
  handleSelectPreference: (preference: any) => void;
  setOpenSavePreferencesModal: (open: boolean) => void;
  selectedTableColumnsPreference?: TableColumnsPreference | null;
  setSelectedTableColumnsPreference: Dispatch<
    SetStateAction<TableColumnsPreference | null>
  >;
};

export default function ToolbarFundIndicatorsTable({
  table,
  disabled,
  walletId,
  handleSelectPreference,
  setOpenSavePreferencesModal,
  selectedTableColumnsPreference,
  setSelectedTableColumnsPreference,
}: ToolbarFundIndicatorsTableProps) {
  const isDisabledSavePreferences = useMemo(
    () => (tableInstance: MRT_TableInstance<any>) => {
      return tableInstance.getState().isSaving;
    },
    [table],
  );

  return (
    <Box display="flex">
      <IconButton
        aria-label="salvar-preferencias"
        onClick={() => setOpenSavePreferencesModal(true)}
        disabled={isDisabledSavePreferences(table)}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&::after': {
            content: '"Salvar"',
            color: disabled ? 'inherit' : '#4F4F4F',
            fontSize: 14,
            fontWeight: 600,
            marginLeft: 1,
          },
        }}>
        <SaveAlt color={disabled ? 'disabled' : 'primary'} />
      </IconButton>
      <MyTablePreferencesButton
        walletId={walletId}
        handleSelectPreference={handleSelectPreference}
        disabled={disabled}
        selectedTableColumnsPreference={selectedTableColumnsPreference}
        setSelectedTableColumnsPreference={setSelectedTableColumnsPreference}
      />
      <MRT_ShowHideColumnsButton
        color="primary"
        title="Personalizar"
        table={table}
        disabled={disabled}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&::after': {
            content: '"Personalizar"',
            color: disabled ? 'inherit' : '#4F4F4F',
            fontSize: 14,
            fontWeight: 600,
            marginLeft: 1,
          },
        }}
      />
      <MRT_ToggleFullScreenButton
        color="primary"
        table={table}
        disabled={disabled}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&::after': {
            content: '"Tela cheia"',
            color: disabled ? 'inherit' : '#4F4F4F',
            fontSize: 14,
            fontWeight: 600,
            marginLeft: 1,
          },
        }}
      />
      <MRT_GlobalFilterTextField table={table} />
    </Box>
  );
}
